<template>
  <v-container fluid class="pl-0 pr-0 pb-0 mt-13">
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-hover v-slot="{ hover }">
          <v-card :elevation="hover ? 16 : 2" shaped>
            <v-card-text>
                <v-layout align-center justify-center column>
                  <v-img class="mr-4" src="assets/images/beneficios/diagnostic.webp" max-height="115" max-width="115" ></v-img>
                  <h5>{{ $t('beneficios_flota_amplia') }}</h5>
                </v-layout>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-hover v-slot="{ hover }">
          <v-card :elevation="hover ? 20 : 2" shaped>
            <v-card-text>
                <v-layout align-center justify-center column>
                  <v-img class="mr-4 p-2" src="assets/images/beneficios/payment.webp" max-height="115" max-width="115" ></v-img>
                  <h5>{{ $t('beneficios_mejor_precio') }}</h5>
                </v-layout>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-hover v-slot="{ hover }">
          <v-card :elevation="hover ? 20 : 2" shaped>
            <v-card-text>
                <v-layout align-center justify-center column>
                  <v-img class="mr-4" src="assets/images/beneficios/reception.webp" max-height="115" max-width="115" ></v-img>
                  <h5>{{ $t('beneficios_soporte') }}</h5>
                </v-layout>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-hover v-slot="{ hover }">
          <v-card :elevation="hover ? 20 : 2" shaped>
            <v-card-text>
                <v-layout align-center justify-center column>
                  <v-img class="mr-4" src="assets/images/beneficios/smartphone.webp" max-height="115" max-width="115" ></v-img>
                  <h5>{{ $t('beneficios_reserva') }}</h5>
                </v-layout>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-hover v-slot="{ hover }">
          <v-card :elevation="hover ? 20 : 2" shaped>
            <v-card-text>
                <v-layout align-center justify-center column>
                  <v-img class="mr-4" src="assets/images/beneficios/chain.webp" max-height="115" max-width="115" ></v-img>
                  <h5>{{ $t('beneficios_kilometraje') }}</h5>
                </v-layout>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-hover v-slot="{ hover }">
          <v-card :elevation="hover ? 20 : 2" shaped>
            <v-card-text>
                <v-layout align-center justify-center column>
                  <v-img src="assets/images/beneficios/driver.webp" max-height="120" max-width="116" ></v-img>
                  <h6 style="font-size: 17px;" >{{ $t('beneficios_conductores') }} </h6>
                </v-layout>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" class="pt-0" align="center">
          <v-container class="pt-0">
            <v-row no-gutters>
              <CardCars/>
            </v-row>
          </v-container>
        </v-col>
    </v-row>
    <!-- Flota -->
    <!-- <v-row class="pt-12">
      <CardCars/>      
    </v-row> -->
  </v-container>
</template>

<script>
import CardCars from '../components/CardCars.vue';

export default {
  name: 'Beneficio',
  components: {
    CardCars
  },
   data: () => ({   
    bannerImagenes : [],
    numPage: 4,
  }),
}
</script>
